module.exports = __webpack_public_path__ + "images/icons_v2/verified-outlined-2f2703ef.svg";